import styled from "styled-components";
import { Field } from "@zendeskgarden/react-forms";

export const InputSearchContainer = styled(Field)`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  position: relative;
  text-align: left;

  label {
    text-align: left;
  }
`;

export const DropdownList = styled.ul`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 100;
  margin: 0;
  padding: 0.25rem 0;
  list-style: none;
  background: var(--color-bg, #fff);
  border: 1px solid var(--color-neutral-300, #d8dcde);
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  max-height: 200px;
  overflow-y: auto;
`;

export const DropdownItem = styled.li`
  padding: 0.4rem 0.75rem;
  font-size: 13px;
  cursor: pointer;
  color: var(--color-text, #2f3941);
  text-align: left;

  &:hover {
    background-color: var(--color-neutral-100, #f3f4f4);
  }
`;

export const DropdownMessage = styled.li`
  padding: 0.4rem 0.75rem;
  font-size: 13px;
  color: var(--color-text-muted, #68737d);
  text-align: left;
  list-style: none;
`;

export const ExpandedList = styled.ul`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  margin: 0;
  padding: 0.25rem 0;
  list-style: none;
  border: 1px solid var(--color-neutral-300, #d8dcde);
  border-radius: 4px;
`;
